import { BarberShopSection } from '~/shared';
import { IListItem } from '../../components/ListTab';
import { createSlice } from '../wrappers';

export enum StageTypes {
	Category = 'category',
	List = 'list',
}

interface BarberShopSlice {
	activeStage: StageTypes;
	activeCategory: BarberShopSection | null;
	activeList: IListItem[];
	activeListIndex: number | null;
	maxListIndex: number;
	primaryColor: string;
	secondaryColor: string;
	opacity: number;
}

const initialState: BarberShopSlice = {
	activeStage: StageTypes.Category,
	activeCategory: null,
	activeList: [] as IListItem[],
	activeListIndex: null,
	maxListIndex: 0,
	primaryColor: '',
	secondaryColor: '',
	opacity: 1,
};

const barberShopSlice = createSlice({
	name: 'barberShop',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setPrimaryColor: (state, action) => {
			state.primaryColor = action.payload;
		},
		setSecondaryColor: (state, action) => {
			state.secondaryColor = action.payload;
		},
		setOpacity: (state, action) => {
			state.opacity = action.payload;
		},
	},
});

export const {
	setActiveStage,
	setActiveCategory,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setPrimaryColor,
	setSecondaryColor,
	setOpacity,
} = barberShopSlice.actions;

export default barberShopSlice.reducer;
